module.exports = __webpack_public_path__ + "pnskfsquadron/img/kr-slider-1.jpg?0fac0dc5";